import { coerceUrl } from '@synapex/tools/utils';
const isLinkToSite = (site, urlLike) => {
    const linkUrl = coerceUrl(urlLike);
    if (!linkUrl) {
        return false;
    }
    return isEqual(pickTitleObj(site), pickTitleObj(linkUrl));
};
const isEqual = (a, b) => a.hostname === b.hostname && a.pathname === b.pathname;
const getTitleString = (site) => {
    //remove all trailing slashes
    return `${site.hostname.replace(/^www\./, '')}${site.pathname.replace(/\/+$/, '')}`;
};
const pickTitleObj = ({ hostname, pathname }) => ({
    hostname: hostname.replace(/^www\./, ''),
    //remove all trailing slashes except the last one if it is the only character left
    pathname: pathname.replace(/(?<=.+)\/+$/, ''),
});
export const siteMethods = {
    isLinkToSite,
    getTitleString,
    pickTitleObj,
    isEqual,
};
//# sourceMappingURL=site.js.map